module.exports = __webpack_public_path__ + "11_mustache_brown.ad7ce88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/11_mustache_brown.png
// module id = tPqF
// module chunks = 0